export default __webpack_public_path__ + "static/media/My Homeoffice-mini.56eb4ae6.jpg";